import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import LevendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
import Bildesveip from './components/bildesveip'
import Wrapper from './components/wrapper'
import './client.css'
const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends BaseElement {
  name = tag

  async render() {
    safeDefine('dh-bildesveip', Bildesveip)
    safeDefine('dh-bildesveip-wrapper', Wrapper)
    safeDefine('dh-bs-levende-stillbilde', LevendeStillbilde)

    if (this.features.kart && typeof customElements.get('dhbs-basis-kart') === 'undefined') {
      const BasisKart = (await import('./kart' /* webpackChunkName: "dh-basis-kart" */)).default
      safeDefine('dh-bs-kart', BasisKart)
    }

    this.addEventListener('dh-basis-sveip-active-changed', (e) => {
      e.preventDefault()
      this.sendGaEvent({ eventAction: 'ACTIVE-CHANGED', eventLabel: e.detail.nextIndex })
    })
  }

  get features() {
    return JSON.parse(this.getAttribute('features'))
  }
}

safeDefine(tag, AppElement)
